// extracted by mini-css-extract-plugin
module.exports = {"days":"kIi7G","day":"_2X8kJ","empty":"_7b3l8"};